import {useState} from "react";
import {t} from "i18next";
import {Tab, Tabs} from "react-bootstrap";
import {useParams} from "react-router-dom";
import CustomerMainTab from "@main/customers/pages/CustomerMainTab";
import AddressesPage from "@bloonde/location/addresses/pages/AddressesPage";
import { ListActionProvider as AddressListActionProvider } from "@bloonde/location/addresses/actions/list/ListActionContext";
import { CreateActionProvider as AddressCreateActionProvider } from "@bloonde/location/addresses/actions/create/CreateActionContext";
import { RemoveActionProvider as AddressRemoveActionProvider } from "@bloonde/location/addresses/actions/remove/RemoveActionContext";
import { EditActionProvider as AddressEditActionProvider } from "@bloonde/location/addresses/actions/edit/EditActionContext";

import { DetailsActionProvider as InvoiceAccountDetailsActionProvider } from "@bloonde/billing/invoice-accounts/actions/details/DetailsActionContext";
import InvoiceAccountMainTab from "@bloonde/billing/invoice-accounts/components/InvoiceAccountMainTab2";
import {ListActionProvider as SuperOrderListProvider} from "@beeldit/ecommerce/super-orders/actions/list/ListActionContext";
import CustomerSuperOrdersPage from "@beeldit/ecommerce/super-orders/pages/CustomerSuperOrdersPage";

function CustomerDashboardPage(props: any) {
    const { filters, title, formDefaultValues } = props;

    let {customerId} = useParams();

    if (!customerId) {
        customerId = "0";
    }

    const addressesFilters = {
        addressable_id: customerId,
        addressable_type: "App\\Models\\Customer",
    };
    const invoiceAccountFormDefaultValues = {
        entity_id: customerId,
        entity_type: "App\\Models\\Customer",
    };

    const [mainDataTabLoaded, setMainDataTabLoaded] = useState(true);

    const onSelect = (key: string) => {
        if (key === "main_data") {
            setMainDataTabLoaded(true);
        }
    };

    return (
        <>
            <Tabs
                defaultActiveKey="main_data"
                id="uncontrolled-tab-example"
                className=""
                onSelect={(key: any) => {
                    onSelect(key);
                }}
            >
                <Tab eventKey="main_data" title={t("main_data")}>
                    {mainDataTabLoaded && (
                        <CustomerMainTab customerId={customerId} title={title} formDefaultValues={formDefaultValues}/>
                    )}
                </Tab>
                <Tab eventKey="addresses" title={t("shipping_addresses")}>
                    <AddressListActionProvider>
                        <AddressRemoveActionProvider>
                            <AddressCreateActionProvider>
                                <AddressEditActionProvider>
                                    <AddressesPage filters={addressesFilters} formDefaultValues={addressesFilters} />
                                </AddressEditActionProvider>
                            </AddressCreateActionProvider>
                        </AddressRemoveActionProvider>
                    </AddressListActionProvider>
                </Tab>
                <Tab eventKey="invoice_account" title={t("invoice_account")}>
                    <InvoiceAccountDetailsActionProvider>
                        <InvoiceAccountMainTab formDefaultValues={invoiceAccountFormDefaultValues} />
                    </InvoiceAccountDetailsActionProvider>
                </Tab>
                <Tab eventKey="orders" title={t("orders")}>
                    <SuperOrderListProvider>
                        <CustomerSuperOrdersPage filters={{customer_id: customerId}} />
                    </SuperOrderListProvider>
                </Tab>
            </Tabs>
        </>
    );
}

export default CustomerDashboardPage;
